export default __webpack_public_path__ + "static/media/420505__jfrecords__uprising2.98bb0890.mp3";